import React from 'react';
import { howItWorks } from '../mock';
import { FileText, CreditCard, CheckCircle } from 'lucide-react';

const iconComponents = { FileText, CreditCard, CheckCircle };

const HowItWorksSection = () => (
  <section className="py-24 bg-white" data-testid="home-how-it-works-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      {/* Header */}
      <div className="text-center mb-16">
        <p className="eyebrow mb-4">How It Works</p>
        <h2 className="font-display text-4xl md:text-5xl font-bold text-[#111C16] tracking-tighter leading-tight">
          Three simple steps
        </h2>
        <p className="font-body text-base text-[#4A5D53] mt-4 max-w-2xl mx-auto">
          From consultation to USPTO registration — we handle everything while you focus on growing your business
        </p>
      </div>

      {/* Steps */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
        {/* removed connecting line */}

        {howItWorks.map((step, index) => {
          const IconComponent = iconComponents[step.icon];
          return (
            <div key={step.id} className="relative text-center group cursor-pointer p-8 rounded-3xl transition-all duration-300 hover:bg-[#F9F8F6] hover:shadow-lg hover:-translate-y-2" data-testid={`how-it-works-step-${index}`}>
              {/* Icon */}
              <div className="flex justify-center mb-6">
                <div className="w-14 h-14 rounded-2xl bg-[#C85A40] flex items-center justify-center transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6">
                  <IconComponent className="h-7 w-7 text-white" strokeWidth={1.5} />
                </div>
              </div>

              {/* Content */}
              <h3 className="font-display text-xl font-bold text-[#111C16] mb-3 transition-colors duration-300 group-hover:text-[#C85A40]">{step.title}</h3>
              <p className="font-body text-sm text-[#4A5D53] leading-relaxed max-w-xs mx-auto">{step.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default HowItWorksSection;
